import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  userRoutes: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      console.log(action.payload);
      state.user = action.payload;
    },
    setRoutes: (state, action) => {
      console.log(action.payload);
      state.userRoutes = action.payload;
    },
  },
});

export const { setUser, setUserRoutes } = userSlice.actions;

export default userSlice.reducer;
